export default __webpack_public_path__ + "media/images/planorama_logo_transparent-d4de1f3486330d2de90bad44daa7529d.png";